export const DEFAULT_IMG =
  "/images/uploads/photo-1516220362602-dba5272034e7.jpeg"
